import { Pagination } from "@mui/material";
import { ReactElement, useContext } from "react";

import { CollectionAssetsContext } from "../../../../providers/collection-assets-provider";

export default function PaginationItems(): ReactElement {
  const { limit, setPage, page, totalCount } = useContext(
    CollectionAssetsContext
  );

  function internalChangePage(value: number): void {
    setPage(value);
  }

  return (
    <Pagination
      sx={{
        "& .MuiButtonBase-root.Mui-selected": {
          backgroundColor: "#4A4A4A",
          color: "white",
        },
      }}
      onChange={(_, page: number) => internalChangePage(page)}
      className="w-full flex justify-center mt-10"
      count={Math.ceil(totalCount / limit)}
      page={page}
      size="large"
    />
  );
}
